module.exports = __webpack_public_path__ + "img/loading.de7a1b54.jpg";